import type { Customization } from '~/types/Customization'
import type { AICustomizationResponse } from '~/api/ai'
import type { PrintType } from '~/types/PrintType'

export function parseAIResponseToCustomization(
  response:
    | AICustomizationResponse
    | {
        parts: Record<string, { color: { id: string } }>
        reasoning: string
        printLogo?: { printType: PrintType }
      },
  currentCustomization: Customization
): Customization {
  const newCustomization: Customization = {
    ...currentCustomization,
    parts: {}
  }

  const parts =
    'parts' in response
      ? response.parts
      : (
          response as unknown as {
            suggestion?: {
              parts?: Record<string, { color: { id: string } }>
            }
          }
        ).suggestion?.parts || {}

  for (const [partId, partData] of Object.entries(parts)) {
    if (partData?.color?.id) {
      newCustomization.parts[partId] = {
        color: { id: (partData as { color: { id: string } }).color.id }
      }
    }
  }

  newCustomization.printName = currentCustomization.printName
  // AIからのprintLogoは無視し、現状の選択を保持する（AIはロゴ非対象）
  newCustomization.printLogo = currentCustomization.printLogo

  return newCustomization
}
